import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default class SummaryItemGridView extends React.Component {
  render() {
    const { hideBrand, hidePerks, hideEquipment, hideFooter } = this.props;

    return (
      <div className="summary-item summary-item-grid">
        <div className="summary-item-grid-header bg-master-light">
          <div className="relative bg-master-light" style={{ paddingTop: '70%' }} />
        </div>

        <div className="summary-item-grid-body">
          {/* title */}
          <h3 className="m-b-5">
            <span className="ms-wireframe" style={{ width: '100%' }}>
              <span className="block bg-master-light" style={{ width: '60%' }}>
                {'\u00A0'}
              </span>
            </span>
          </h3>
          {!hideBrand && (
            <h6 className="m-b-10">
              <span className="ms-wireframe" style={{ width: '100%' }}>
                <span className="block bg-master-light" style={{ width: '25%' }}>
                  {'\u00A0'}
                </span>
              </span>
            </h6>
          )}

          {/* details */}
          {!hideEquipment && (
            <Row className="no-margin">
              <Col xs={6} className="no-padding">
                <i className="fas fa-circle text-master-lighter m-r-5" />
                <span className="ms-wireframe" style={{ width: '50%' }}>
                  <span className="block bg-master-light lh-12" style={{ width: '100%' }}>
                    {'\u00A0'}
                  </span>
                </span>
              </Col>
              <Col xs={6} className="no-padding">
                <i className="fas fa-circle text-master-lighter m-r-5" />
                <span className="ms-wireframe" style={{ width: '50%' }}>
                  <span className="block bg-master-light lh-12" style={{ width: '100%' }}>
                    {'\u00A0'}
                  </span>
                </span>
              </Col>
              <Col xs={6} className="no-padding">
                <i className="fas fa-circle text-master-lighter m-r-5" />
                <span className="ms-wireframe" style={{ width: '50%' }}>
                  <span className="block bg-master-light lh-12" style={{ width: '100%' }}>
                    {'\u00A0'}
                  </span>
                </span>
              </Col>
              <Col xs={6} className="no-padding">
                <i className="fas fa-circle text-master-lighter m-r-5" />
                <span className="ms-wireframe" style={{ width: '50%' }}>
                  <span className="block bg-master-light lh-12" style={{ width: '100%' }}>
                    {'\u00A0'}
                  </span>
                </span>
              </Col>
              <Col xs={6} className="no-padding">
                <i className="fas fa-circle text-master-lighter m-r-5" />
                <span className="ms-wireframe" style={{ width: '50%' }}>
                  <span className="block bg-master-light lh-12" style={{ width: '100%' }}>
                    {'\u00A0'}
                  </span>
                </span>
              </Col>
              <Col xs={6} className="no-padding">
                <i className="fas fa-circle text-master-lighter m-r-5" />
                <span className="ms-wireframe" style={{ width: '50%' }}>
                  <span className="block bg-master-light lh-12" style={{ width: '100%' }}>
                    {'\u00A0'}
                  </span>
                </span>
              </Col>
            </Row>
          )}

          <div className="m-t-15">
            <h3 className="no-margin text-center">
              {/* price */}
              <span className="ms-wireframe" style={{ width: '50%' }}>
                <span className="block bg-master-light" style={{ width: '100%' }}>
                  {'\u00A0'}
                </span>
              </span>
            </h3>
          </div>
        </div>
      </div>
    );
  }
}
SummaryItemGridView.defaultProps = {
  hideBrand: false,
  hidePerks: false,
  hideEquipment: false,
  hideFooter: true,
};
